/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthenticationService } from './services/authentication.service';
import { ChargerConnectorService } from './services/charger-connector.service';
import { ChargerLocationService } from './services/charger-location.service';
import { ChargingDataAnalysisService } from './services/charging-data-analysis.service';
import { ChargingDataAnalysisSyncService } from './services/charging-data-analysis-sync.service';
import { CompanyService } from './services/company.service';
import { ExternalAuthenticationService } from './services/external-authentication.service';
import { PaymentService } from './services/payment.service';
import { UserService } from './services/user.service';
import { WebsiteService } from './services/website.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthenticationService,
    ChargerConnectorService,
    ChargerLocationService,
    ChargingDataAnalysisService,
    ChargingDataAnalysisSyncService,
    CompanyService,
    ExternalAuthenticationService,
    PaymentService,
    UserService,
    WebsiteService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
